import { useLanguage } from "@/context/LanguageContext";

const SolutionsSection = () => {
  const { copy } = useLanguage();

  return (
    <section className="section section-alt" id="solutions" data-testid="solutions-section">
      <div className="container" data-testid="solutions-container">
        <div className="section-header">
          <p className="section-kicker" data-testid="solutions-kicker">
            {copy.solutions.kicker}
          </p>
          <h2 className="section-title" data-testid="solutions-title">
            {copy.solutions.title}
          </h2>
        </div>
        <div className="card-grid" data-testid="solutions-grid">
          {copy.solutions.items.map((solution, index) => (
            <div className="solution-card" key={solution.title} data-testid={`solution-card-${index}`}>
              <h3 data-testid={`solution-title-${index}`}>{solution.title}</h3>
              <p data-testid={`solution-description-${index}`}>{solution.description}</p>
            </div>
          ))}
        </div>
        <a href="#contact" className="text-link" data-testid="solutions-contact-link">
          {copy.solutions.cta}
        </a>
      </div>
    </section>
  );
};

export default SolutionsSection;